module.exports = __webpack_public_path__ + "media/72_Long.5ede6cea.mp3";